import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useAuth } from '@/features/auth/hooks/useAuth';
import { ACCOUNT_QUERY_KEYS } from '@/lib/constants/account';
import { AccountApi } from '../AccountApi';
import type { IngestcfgData } from '@/lib/types/Ingest';

/**
 * Fetches upload profiles (ingestcfgs) for the currently selected account.
 * Note: API returns a bare array, NOT IListRes — no .data unwrapping needed.
 */
export function useUploadProfiles() {
  const { selectedCId } = useAuth();

  const query = useQuery<IngestcfgData[]>({
    queryKey: ACCOUNT_QUERY_KEYS.uploadProfiles(selectedCId ?? 0),
    queryFn: () => AccountApi.getUploadProfiles(selectedCId!),
    enabled: selectedCId != null,
    staleTime: 2 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });

  const uploadProfiles: IngestcfgData[] = useMemo(
    () => query.data ?? [],
    [query.data],
  );

  return {
    uploadProfiles,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
